module.exports = __webpack_public_path__ + "static/media/regionalbank.3046d2eb.jpg";